<template>
  <div class="revise-number">
    <!-- 步骤条 -->
    <div class="step-list">
      <el-steps :active="active" finish-status="success" simple>
        <el-step title="验证原手机号"></el-step>
        <el-step title="验证新手机号"></el-step>
        <el-step title="修改完成"></el-step>
      </el-steps>
    </div>
    <!-- 原号码 -->
    <div class="phone-container" v-show="active == 0">
      <div class="revise-number-title">验证原手机号</div>
      <el-form
        label-position="left"
        label-width="80px"
        :model="originalPhoneForm"
        ref="originalPhoneFormRef"
        :rules="phoneFormRules"
      >
        <el-form-item label="原手机号" prop="phone">
          <el-input v-model="phone" @input="originalPhoneInput" disabled>
            <div slot="suffix" class="pass" v-show="isCorrectOldPhone == 1">
              <img src="~@/assets/image/reviseNumber/pass.png" alt="" />
            </div>
            <div slot="suffix" class="pass" v-show="isCorrectOldPhone == 2">
              <img src="~@/assets/image/reviseNumber/error.png" alt="" />
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="originalPhoneForm.code">
            <vcode
              @click.native="originalPhoneGetCode"
              ref="originalPhoneCode"
              slot="suffix"
              :localName="originalPhoneNumberCode"
              class="vcode"
              @countDownOver="countDownOver"
              :duration="codeTime"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <div class="submit-button-cotainer">
        <el-button type="primary" class="submit-button" @click="originalPhoneSubmit"
          >下一步</el-button
        >
      </div>
    </div>
    <!-- 新号码 -->
    <div class="phone-container" v-show="active == 1">
      <div class="revise-number-title">请输入新手机号</div>
      <el-form
        label-position="left"
        label-width="80px"
        :model="newPhoneForm"
        ref="newPhoneFormRef"
        :rules="phoneFormRules"
      >
        <el-form-item label="新手机号" prop="newPhone">
          <el-input v-model="newPhoneForm.newPhone" @input="newPhoneInput">
            <div slot="suffix" class="pass" v-show="isCorrectNewPhone == 1">
              <img src="~@/assets/image/reviseNumber/error.png" alt="" />
            </div>
            <div slot="suffix" class="pass" v-show="isCorrectNewPhone == 2">
              <img src="~@/assets/image/reviseNumber/pass.png" alt="" /></div
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="newPhoneForm.code">
            <vcode
              @click.native="newPhoneGetCode"
              ref="newPhoneCode"
              slot="suffix"
              :localName="newPhoneNumberCode"
              class="vcode"
              @countDownOver="countDownOver"
              :duration="codeTime"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <div class="submit-button-cotainer">
        <el-button type="primary" class="submit-button" @click="newPhoneSubmit"
          >确认修改</el-button
        >
      </div>
    </div>
    <!-- 完成修改 -->
    <div class="submit-success" v-show="active == 3">
      <img src="~@/assets/image/common/success.png" alt="" />
      <el-button @click="confirm">返回</el-button>
    </div>
  </div>
</template>

<script>
import JSEncrypt from "@/js_sdk/jsencrypt-Rsa/jsencrypt/jsencrypt.min.js";
import vcode from "@/components/code/code";
import { mapActions } from "vuex";
export default {
  components: {
    vcode,
  },
  data() {
    // let phoneCodeVerification = /^[1][3,4,5,6, 7,8, 9][0-9]{9}$/;
    // const validateNewPhone = (rule, value, callback) => {
    //   this.isGetNewVcode = false;
    //   if (value === "") {
    //     callback(new Error("手机号码不能为空"));
    //   } else if (!phoneCodeVerification.test(value)) {
    //     callback(new Error("请输入正确的手机号"));
    //   } else {
    //     // 获取验证码可以点击
    //     this.isGetNewVcode = true;
    //     callback();
    //   }
    // };
    return {
      phone: "", // 展示的加星手机号
      isCorrectOldPhone: 0, // 数据库是否有此原手机号，1有，2没有
      isCorrectNewPhone: 0, // 数据库是否有此新手机号，1有，2没有
      active: 0, // 显示步骤 0：原手机 1：新手机 3：修改完成
      originalPhoneNumberCode: "originalPhoneNumberCode",
      newPhoneNumberCode: "newPhoneNumberCode",
      originalPhoneForm: {
        phone: "",
        code: "",
      },
      newPhoneForm: {
        newPhone: "",
        code: "",
      },
      phoneFormRules: {
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
        ],
        code: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" },
        ],
        // newPhone: [{ validator: validateNewPhone, trigger: "blur" }],
        newPhone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
        ],
      },

      isGetOldVcode: false, // 是否可以获取旧手机验证码
      isGetNewVcode: false, // 是否可以获取新手机验证码
      codeTime: 10, // 验证码倒计时
      publicKey: "", // 公钥
      encryptorNewPhone: "", // 新手机加密后
    };
  },
  created() {
    this.originalPhoneForm.phone = this.user.phone;
    this.phone = this.user.phone.substr(0, 3) + "****" + this.user.phone.substr(7);
  },
  methods: {
    ...mapActions(["resetLoginHandled"]),
    // 获取原手机验证码前，判断原手机是否在数据库，没有不能获取验证码
    originalPhoneInput() {
      this.isGetOldVcode = false;
      if (this.originalPhoneForm.phone.length < 11) return;

      console.log("this.user.phone==>", this.user.phone);
      if (!this.user.phone) {
        let phoneCodeVerification = /^1[3-9][0-9]{9}$/;
        if (!phoneCodeVerification.test(this.originalPhoneForm.phone)) {
          return this.$message.warning("请填写正确格式的手机号");
        }
        this.post(this.$url.selectTeacherPhonePC, {
          phone: this.originalPhoneForm.phone,
        })
          .then((res) => {
            // console.log(res);
            if (res.code == 500) {
              this.isCorrectOldPhone = 2;
              this.$message("不存在该手机号");
            } else if (res.code == 200) {
              //数据库有该手机号
              this.isCorrectOldPhone = 1;
              this.isGetOldVcode = true;
            }
          })
          .catch((err) => {
            this.$message.error("查找手机号码失败，请稍后再试");
          });
      } else {
        this.isCorrectOldPhone = 1;
        this.isGetOldVcode = true;
      }
    },
    // 获取原手机号验证码
    originalPhoneGetCode() {
      this.originalPhoneInput();
      if (!this.isGetOldVcode) {
        return this.$message.warning("请先填写正确的手机号");
      }
      this.$refs.originalPhoneCode.getCode();
      // 获取验证码
      this.post(this.$url.selectBeforePhoneVcodePC, {
        phone: this.originalPhoneForm.phone,
      })
        .then((res) => {
          // console.log(res);
          let data = res;
          if (data.code == 200) {
            return this.$message.success("获取验证码成功");
          } else {
            return this.$message.error(data.msg);
          }
        })
        .catch((err) => {
          return this.$message.error("获取验证码失败，请稍后重试");
        });
    },
    // 原手机号提交
    originalPhoneSubmit() {
      this.$refs.originalPhoneFormRef.validate((valid) => {
        if (valid) {
          // 将原手机号和验证码提交
          this.post(this.$url.selectTeacherAccountAndSecurityPC, {
            phone: this.originalPhoneForm.phone,
            vcode: this.originalPhoneForm.code,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                // 显示输入新手机号表单
                this.active = 1;
              } else if (res.code == 500) {
                this.$message.error(res.msg);
              } else {
                //提示失败
                this.$message.error("操作失败");
                return;
              }
            })
            .catch((err) => {
              this.$message.error("操作失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
    // 获取新手机验证码前，判断新手机是否在数据库，有不能获取验证码
    newPhoneInput() {
      this.isGetNewVcode = false;
      if (this.newPhoneForm.newPhone.length < 11) return;

      let phoneCodeVerification = /^1[3-9][0-9]{9}$/;
      if (!phoneCodeVerification.test(this.newPhoneForm.newPhone)) {
        return this.$message.warning("请填写正确格式的手机号");
      }
      this.post(this.$url.selectTeacherPhonePC, {
        phone: this.newPhoneForm.newPhone,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            //数据库有该手机号
            this.isCorrectNewPhone = 1;
            this.$message.warning("该手机号已存在，请重新填写");
          } else {
            this.isCorrectNewPhone = 2;
            this.isGetNewVcode = true;
          }
        })
        .catch((err) => {
          this.$message.error("查找数据失败，请稍后再试");
        });
    },
    // 点击获取新手机号验证码
    newPhoneGetCode() {
      if (!this.isGetNewVcode) {
        return this.$message.warning("请先填写正确的手机号");
      }
      this.$refs.newPhoneCode.getCode();
      // 获取公钥，加密手机号
      this.getEncryp(this.newPhoneForm.newPhone);
    },
    //验证码倒计时结束
    countDownOver() {
      // console.log("倒计时结束");
    },
    //获取公钥
    getEncryp(phone) {
      this.post(this.$url.getEncryp)
        .then((res) => {
          this.publicKey = res.msg;
          //获取到公钥，加密手机号
          this.encryptPhoneNum(phone);
        })
        .catch((err) => {
          this.$message.error("获取公钥失败，请检查网络后重试");
        });
    },
    // 公钥加密，获取新手机号验证码
    encryptPhoneNum(eventValue) {
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(this.publicKey); // 设置公钥
      this.encryptorNewPhone = encryptor.encrypt(eventValue); // 对数据进行加密
      // 获取验证码 this.encryptorNewPhone（新手机加密后）
      this.post(this.$url.selectUpdatePhoneVcode, {
        phone: this.encryptorNewPhone,
      })
        .then((res) => {
          // console.log(res);
          let data = res;
          if (data.code != 200) {
            return this.$message("获取验证码失败");
          }
          return this.$message(data.msg);
        })
        .catch((err) => {
          return this.$message.error("获取验证码失败，请稍后重试");
        });
    },
    //新手机号提交
    newPhoneSubmit() {
      // console.log(this.user.id, this.encryptorNewPhone, this.newPhoneForm.code);
      this.$refs.newPhoneFormRef.validate((valid) => {
        if (valid) {
          this.post(this.$url.updateTeacherByPhone, {
            id: this.user.id,
            phone: this.encryptorNewPhone,
            vcode: this.newPhoneForm.code,
          })
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("修改成功");
                this.active = 3;
              } else if (res.code == 500) {
                this.$message.error(res.msg);
              } else {
                //提示失败
                this.$message.error("修改失败");
                return;
              }
            })
            .catch((err) => {
              this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
    // 确定按钮，显示步骤1
    confirm() {
      this.active = 0;
    },
    showLogoutConfirm() {
      this.$confirm("修改成功，请重新登录！", {
        confirmButtonText: "确定",
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.get(this.$url.exitLogin).then((res) => {
            // 删除token并转到登录页面重新登录
            this.$store.dispatch("user/resetToken").then(() => {
              this.resetLoginHandled();
              this.$router.push("/login");
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
@import "./reviseNumber.scss";
</style>
